var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","my-5":"","column":""}},[_c('v-flex',[_vm._v("\n        Health Ok!\n      ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }